import styled from 'styled-components';
const MyDiv = styled.div`
  .page_wrapper {
    background-color: #fff;
    border-radius: 10px;
    padding: 16px 20px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    margin-bottom: 12px;
  }

  .flex_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }

  .filter_section {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .icon_btn {
    width: 34px;
    height: 34px;
    padding: 2px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background-color: #fff;
    cursor: pointer;
    transition: background-color 0.2s ease, border-color 0.2s ease;
  }

  .icon_btn:hover {
    background-color: #F0F5F1;
    border-color: #006838;
  }

  .chakra-input {
    font-family: "Poppins", sans-serif !important;
    font-size: 13px !important;
    border-radius: 6px !important;
    border-color: #e2e8f0 !important;
    height: 34px !important;
  }

  .chakra-input:focus {
    border-color: #006838 !important;
    box-shadow: 0 0 0 1px #006838 !important;
  }

  .chakra-button {
    font-family: "Poppins", sans-serif !important;
    font-size: 12px !important;
    border-radius: 6px !important;
    border-color: #e2e8f0 !important;
    height: 34px !important;
    color: #333 !important;
    background-color: #fff !important;
    transition: border-color 0.2s ease, background-color 0.2s ease !important;
  }

  .chakra-button:hover {
    border-color: #006838 !important;
    background-color: #F0F5F1 !important;
  }

  .chakra-table {
    border-collapse: separate !important;
    border-spacing: 0 !important;
    width: 100% !important;
  }

  .chakra-table thead tr th {
    font-family: "Poppins", sans-serif !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #555 !important;
    background-color: #F0F5F1 !important;
    padding: 10px 14px !important;
    border-bottom: 1px solid #e2e8f0 !important;
    white-space: nowrap;
    text-transform: none !important;
    letter-spacing: 0 !important;
  }

  .chakra-table thead tr th:first-child {
    border-radius: 8px 0 0 8px !important;
  }

  .chakra-table thead tr th:last-child {
    border-radius: 0 8px 8px 0 !important;
  }

  .chakra-table tbody tr td {
    font-family: "Poppins", sans-serif !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    color: #333 !important;
    padding: 10px 14px !important;
    border-bottom: 1px solid #f0f0f0 !important;
    vertical-align: middle !important;
  }

  .chakra-table tbody tr:last-child td {
    border-bottom: none !important;
  }

  .chakra-table tbody tr:hover td {
    background-color: #fafafa !important;
  }

  .empId {
    background-color: #e8f4ee !important;
    color: #006838 !important;
    border-radius: 4px !important;
    padding: 2px 8px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    font-family: "Poppins", sans-serif !important;
    cursor: default;
  }

  .status_badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 11px !important;
    font-weight: 500 !important;
    font-family: "Poppins", sans-serif !important;
    white-space: nowrap;
  }

  .status_badge.green {
    background-color: #e6f4ec;
    color: #006838;
  }

  .status_badge.red {
    background-color: #fdecea;
    color: #c0392b;
  }

  .status_badge.orange {
    background-color: #fff4e5;
    color: #d46b08;
  }

  .status_badge.yellow {
    background-color: #fffbe6;
    color: #b8860b;
  }

  .status_badge.purple {
    background-color: #f3eeff;
    color: #6b21a8;
  }

  .status_badge.blue {
    background-color: #e8f0fe;
    color: #1a56db;
  }

  .status_badge.pink {
    background-color: #fde8f3;
    color: #9d174d;
  }

  .status_badge.cyan {
    background-color: #e0f7fa;
    color: #00796b;
  }

  .status_badge.gray {
    background-color: #f0f0f0;
    color: #555;
  }

  .chakra-popover__content {
    border-radius: 10px !important;
    border: 1px solid #e2e8f0 !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
    font-family: "Poppins", sans-serif !important;
  }

  .react-calendar {
    border: none !important;
    font-family: "Poppins", sans-serif !important;
    font-size: 13px !important;
    width: 280px !important;
  }

  .react-calendar__navigation button {
    font-family: "Poppins", sans-serif !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    color: #333 !important;
    background: none !important;
    border-radius: 6px !important;
    min-width: 32px !important;
  }

  .react-calendar__navigation button:hover {
    background-color: #F0F5F1 !important;
  }

  .react-calendar__tile {
    font-family: "Poppins", sans-serif !important;
    font-size: 12px !important;
    border-radius: 6px !important;
    padding: 6px 4px !important;
    color: #333 !important;
  }

  .react-calendar__tile:hover {
    background-color: #F0F5F1 !important;
    color: #006838 !important;
  }

  .react-calendar__tile--active,
  .react-calendar__tile--active:hover {
    background-color: #006838 !important;
    color: #fff !important;
    font-weight: 600 !important;
  }

  .react-calendar__tile--now {
    background-color: #e8f4ee !important;
    color: #006838 !important;
    font-weight: 600 !important;
  }

  .react-calendar__tile--now.react-calendar__tile--active {
    background-color: #006838 !important;
    color: #fff !important;
  }

  .react-calendar__month-view__weekdays__weekday {
    font-family: "Poppins", sans-serif !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    color: #888 !important;
    text-decoration: none !important;
  }

  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none !important;
  }

  .react-calendar__tile:disabled {
    color: #ccc !important;
    background-color: transparent !important;
    cursor: not-allowed !important;
  }

  .chakra-modal__content {
    border-radius: 12px !important;
    font-family: "Poppins", sans-serif !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  }

  .chakra-modal__header {
    font-family: "Poppins", sans-serif !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #1a1a1a !important;
    border-bottom: 1px solid #f0f0f0 !important;
    padding-bottom: 12px !important;
  }
  .chakra-modal__body {
    padding: 16px 24px !important;
  }
  .chakra-select {
    font-family: "Poppins", sans-serif !important;
    font-size: 12px !important;
    border-color: #e2e8f0 !important;
    border-radius: 6px !important;
    height: 32px !important;
  }
  .chakra-select:focus {
    border-color: #006838 !important;
    box-shadow: 0 0 0 1px #006838 !important;
  }`;
export default MyDiv;